export default "__VITE_ASSET__ClRB3LZX__"